import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { SessionService } from '@/app/core/services/session';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(SessionService).getToken();

  if (token) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token),
    });

    return next(authReq);
  }

  return next(req);
};
